import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import CustomerReminderBoard from '../components/CustomerReminderBoard';
import CustomerDetailsModal from '../components/CustomerDetailsModal';
import { getReminder, type WorkCustomer, type WorkReminder } from '../api/client';
import { useAuth } from '../context/AuthContext';
import { workError } from '../lib/customerWork';

export default function Reminders() {
  const { t } = useTranslation();
  const { user } = useAuth();
  const [params] = useSearchParams();
  const [customer, setCustomer] = useState<WorkCustomer>();
  const [linked, setLinked] = useState<WorkReminder>();
  const [error, setError] = useState('');
  const reminderId = params.get('reminder');
  const wrongWorkspace = Boolean(params.get('workspace') && params.get('workspace') !== user?.tenant_id);
  useEffect(() => {
    let active = true;
    setCustomer(undefined); setLinked(undefined); setError('');
    if (reminderId && !wrongWorkspace) {
      getReminder(reminderId).then(({ data }) => {
        if (active) setLinked(data as WorkReminder);
      }).catch(e => { if (active) setError(workError(e, t('customerWork.loadError'))); });
    }
    return () => { active = false; };
  }, [reminderId, user?.tenant_id, wrongWorkspace, t]);
  return <div className="space-y-5">
    <h1 className="text-2xl font-bold">{t('reminders.title')}</h1>
    <p className="text-gray-600">{t('customerWork.pageDescription')}</p>
    {wrongWorkspace && <p role="alert" className="text-amber-700">{t('customerWork.switchWorkspace')}</p>}
    {error && <p role="alert" className="text-red-700">{error}</p>}
    {linked && <div className="rounded border border-primary-300 p-3">
      <p className="font-semibold">{linked.title}</p>
      <p>{linked.description}</p>
      {linked.customer_id && <button className="text-primary-700 underline" onClick={() => setCustomer({
        customer_id: linked.customer_id!, provider: linked.provider, customer_name: linked.customer_name ?? linked.customer_id!,
      })}>{linked.customer_name}</button>}
    </div>}
    <CustomerReminderBoard key={user?.tenant_id} openCustomer={setCustomer} />
    {customer && <CustomerDetailsModal operationalOnly provider={customer.provider}
      operationalCustomerId={customer.customer_id} displayName={customer.customer_name}
      onClose={() => setCustomer(undefined)} />}
  </div>;
}
